import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import { followAthlete } from 'api/athlete';
import FriendListItem from 'components/shared/facebook/FriendListItem';
import {
  FOLLOW_ACTIONS,
  FOLLOWING_STATUS
} from 'constants/follows/following-constants';
import { t } from '../../../../../../shared/onboarding-utils';
import { useOnboardingContext } from '../../../../../../state/OnboardingContext';
import {
  ADD_ALERT,
  CLEAR_ALERT
} from '../../../../../../state/Onboarding.actions';

const OnboardingFriendEntry = ({ friend }) => {
  const { state, dispatch, track } = useOnboardingContext();
  // onboarding only shows friends who are not yet followed
  const [cta, setCta] = useState(
    friend.approveFollowers
      ? FOLLOW_ACTIONS.requestToFollow
      : FOLLOW_ACTIONS.follow
  );
  const [isProcessing, setIsProcessing] = useState(false);
  const [friendIsFollowable, setFriendIsFollowable] = useState(
    friend.isFollowable
  );

  const handleBtnClick = () => {
    setIsProcessing(true);
    dispatch({ type: CLEAR_ALERT });

    followAthlete({
      followerId: state.currentAthlete.id,
      followingId: friend.id
    })
      .then((status) => {
        track({
          element: cta,
          action: 'click',
          properties: {
            athlete_id: friend.id,
            following_status: status
          }
        });
        if (status === FOLLOWING_STATUS.error) {
          dispatch({
            type: ADD_ALERT,
            payload: {
              severity: 'error',
              message: t('errors.generic')
            }
          });
        } else {
          setCta(status);
          setFriendIsFollowable(false);
        }
      })
      .finally(() => setIsProcessing(false));
  };

  return (
    <FriendListItem friend={friend}>
      <Button
        type="button"
        variant="primary"
        onClick={handleBtnClick}
        disabled={!friendIsFollowable || isProcessing}
      >
        {t(`cta_actions.${cta}`)}
      </Button>
    </FriendListItem>
  );
};

OnboardingFriendEntry.propTypes = {
  friend: PropTypes.shape({
    approveFollowers: PropTypes.bool,
    followingStatus: PropTypes.oneOf(Object.values(FOLLOWING_STATUS)),
    id: PropTypes.number,
    isFollowable: PropTypes.bool
  }).isRequired
};

export default OnboardingFriendEntry;
